export const products = [
  // T-Shirts
  {
    id: 1,
    name: 'Classic Go4Profit T-Shirt',
    price: 24.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1759572095384-1a7e646d0d4f?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fFQtU2hpcnR8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=600',
    description: 'Premium cotton t-shirt with Go4Profit logo'
  },
  {
    id: 2,
    name: 'Premium Go4Profit Polo',
    price: 34.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1625910513413-c23b8bb81cba?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=687',
    description: 'Professional polo shirt for the office'
  },
  {
    id: 3,
    name: 'Go4Profit Hat',
    price: 22.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1521369909029-2afed882baee?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8SGF0fGVufDB8fDB8fHww&auto=format&fit=crop&q=60&w=600',
    description: 'Stylish branded cap'
  },
  {
    id: 4,
    name: 'Long Sleeve Go4Profit Shirt',
    price: 29.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TG9uZyUyMFNsZWV2ZSUyMHNoaXJ0fGVufDB8fDB8fHww&auto=format&fit=crop&q=60&w=600',
    description: 'Perfect for cooler weather'
  },

  // Hoodies
  {
    id: 5,
    name: 'Go4Profit Hoodie - Black',
    price: 49.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1680292783974-a9a336c10366?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8SG9vZGllJTIwLSUyMEJsYWNrfGVufDB8fDB8fHww&auto=format&fit=crop&q=60&w=600',
    description: 'Cozy black hoodie with embroidered logo'
  },
  {
    id: 6,
    name: 'Go4Profit Hoodie - Navy',
    price: 49.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?w=400&h=400&fit=crop',
    description: 'Navy blue premium hoodie'
  },
  {
    id: 7,
    name: 'Go4Profit Hoodie',
    price: 54.99,
    category: 'apparel',
    image: 'https://images.unsplash.com/photo-1746945021381-86bca45b2cc7?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fFppcCUyMEhvb2RpZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=60&w=600',
    description: 'Convenient zip-up design'
  },

  // Pens
  {
    id: 8,
    name: 'Go4Profit Premium Pen Set',
    price: 12.99,
    category: 'stationery',
    image: 'https://images.unsplash.com/photo-1744367848793-8d83c799fc13?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8UHJlbWl1bSUyMFBlbiUyMFNldHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=60&w=600',
    description: 'Set of 5 quality pens'
  },
  {
    id: 9,
    name: 'Go4Profit Executive Pen',
    price: 19.99,
    category: 'stationery',
    image: 'https://images.unsplash.com/photo-1600531597946-f9b1d7b0f486?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fEV4ZWN1dGl2ZSUyMFBlbnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=60&w=600',
    description: 'Elegant metal pen with gift box'
  },
  {
    id: 10,
    name: 'Go4Profit Stylus Pen',
    price: 15.99,
    category: 'stationery',
    image: 'https://images.unsplash.com/photo-1585336261022-680e295ce3fe?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fEV4ZWN1dGl2ZSUyMFBlbnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=60&w=600',
    description: '2-in-1 pen and stylus'
  },

  // Cups/Mugs
  {
    id: 11,
    name: 'Go4Profit Coffee Mug',
    price: 14.99,
    category: 'drinkware',
    image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=400&h=400&fit=crop',
    description: 'Classic ceramic mug'
  },
  {
    id: 12,
    name: 'Go4Profit Travel Mug',
    price: 19.99,
    category: 'drinkware',
    image: 'https://images.unsplash.com/photo-1642698043660-a3827ca09337?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8VHJhdmVsJTIwTXVnfGVufDB8fDB8fHww&auto=format&fit=crop&q=60&w=600',
    description: 'Insulated stainless steel'
  },
  {
    id: 13,
    name: 'Go4Profit Cup Set',
    price: 24.99,
    category: 'drinkware',
    image: 'https://images.unsplash.com/photo-1700069547648-14286efacf1a?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTl8fG11ZyUyMHNldHxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=60&w=600',
    description: 'Set of 4 elegant glass cups'
  },

  // Notebooks
  {
    id: 14,
    name: 'Go4Profit Leather Journal',
    price: 29.99,
    category: 'stationery',
    image: 'https://images.unsplash.com/photo-1531346878377-a5be20888e57?w=400&h=400&fit=crop',
    description: 'Premium leather-bound notebook'
  },
  {
    id: 15,
    name: 'Go4Profit Spiral Notebook',
    price: 9.99,
    category: 'stationery',
    image: 'https://images.unsplash.com/photo-1517842645767-c639042777db?w=400&h=400&fit=crop',
    description: 'Practical spiral-bound notebook'
  },
  {
    id: 16,
    name: 'Go4Profit Planner',
    price: 24.99,
    category: 'stationery',
    image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=400&h=400&fit=crop',
    description: 'Annual planner for productivity'
  },

  // Bags
  {
    id: 17,
    name: 'Go4Profit Tote Bag',
    price: 19.99,
    category: 'bags',
    image: 'https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=400&h=400&fit=crop',
    description: 'Eco-friendly canvas tote'
  },
  {
    id: 18,
    name: 'Go4Profit Backpack',
    price: 59.99,
    category: 'bags',
    image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop',
    description: 'Professional laptop backpack'
  },
  {
    id: 19,
    name: 'Go4Profit Gym Bag',
    price: 34.99,
    category: 'bags',
    image: 'https://images.unsplash.com/photo-1692506530242-c12d6c3ae2e2?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R3ltJTIwQmFnfGVufDB8fDB8fHww&auto=format&fit=crop&q=60&w=600',
    description: 'Durable gym duffle bag'
  },

  // Thermos/Water Bottles
  {
    id: 20,
    name: 'Go4Profit Thermos Flask',
    price: 29.99,
    category: 'drinkware',
    image: 'https://images.unsplash.com/photo-1592985666128-a89274277995?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VGhlcm1vcyUyMEZsYXNrfGVufDB8fDB8fHww&auto=format&fit=crop&q=60&w=600',
    description: 'Keeps drinks hot for 12 hours'
  },
];
